"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumToggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
function PremiumToggle({ isProUser, checked, onChange, showProUserPaywall, }) {
    const handleOnChangeEvent = (checked) => {
        if (!isProUser) {
            return;
        }
        onChange && onChange(checked);
    };
    const handleOnClickEvent = (event) => {
        if (!isProUser) {
            event.stopPropagation();
            event.preventDefault();
            showProUserPaywall(true);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { onClick: handleOnClickEvent, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Switch, { checked: checked, onChange: handleOnChangeEvent, name: 'switch-customised-logo' }) }));
}
exports.PremiumToggle = PremiumToggle;
//# sourceMappingURL=PremiumToggle.js.map